import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVerticalAlignmentLeft"><Path d="M3.5 3.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 6.5H6.5V10.5H20.5V6.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 13.5H6.5V17.5H16.5V13.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVerticalAlignmentLeft;
